import TextType from './TextType';

abstract class Node {

	public abstract toText (textType?: TextType): string;

	public abstract normalized (): Node;
}

export default Node;


// WEBPACK FOOTER //
// ./code/project/modules/parsing/nodes/Node.ts